export default __webpack_public_path__ + "static/media/liked.8957fdc2.svg";